"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=ShimmeredDetailsList.types.js.map